import React from 'react'
import {Text} from '@vio/atlas/Text'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

export type CashbackVariant = 'short' | 'long'
export interface CashbackProps {
  value: number
  type: string
  variant?: CashbackVariant
}

const Wards = ({value}: Pick<CashbackProps, 'value'>) => {
  return (
    <>
      <Text
        tag="span"
        variant="bodyXS"
        colorPath="content.brand.c500"
        style={{textDecoration: 'line-through'}}
      >
        W
      </Text>
      <Text tag="span" variant="bodyXS" colorPath="content.brand.c500">
        {value}
      </Text>
    </>
  )
}

export const Cashback = ({value, type, variant = 'long'}: CashbackProps) => {
  if (type !== 'points') return null

  return (
    <Text
      variant="bodyXS"
      tag="span"
      colorPath="content.neutral.c600"
      style={{whiteSpace: 'nowrap'}}
    >
      {variant === 'short' ? (
        <Wards value={value} />
      ) : (
        <FormattedMessageWrapper
          id="cashback.longMessage"
          defaultMessage="Earn {value}"
          values={{
            value: <Wards value={value} />
          }}
        />
      )}
    </Text>
  )
}
